import request from '../utils/request';
//展商信息

//展商注册信息接口
export function addexhition(data) {
  return request({
    url: '/onlineExhibition/frontExhibitor/register',
    method: 'post',
    params: data,
  });
}
//编辑展商
export function editexhition(data) {
  return request({
    url: '/frontExhibitor/exhibitor/edit',
    method: 'post',
    data: data,
  });
}
//获取展商信息
export function getExhition() {
  return request({
    url: '/frontExhibitor/exhibitor/view',
    method: 'get',
  });
}
//获取当前登录展商的展位
export function getBooth(data) {
  return request({
    url: '/frontExhibitor/exhibitor/viewBoothInformation?lang='+data,
    method: 'get',
  });
}
